import React, { useEffect, useState } from 'react';
import { espotAPI } from '../../../../public/constants/constants';
import apiManager from '../../../utils/apiManager';
import { isMobile } from '../../../utils/utilityManager';
import Form from '../Homepage/Form';
import GlimpseInto from './GlimpseInto';
import ImagesContainer from './ImagesContainer';
import PartnersPanel from '../OrphanPage/partnersPanel';
import OwnDay from '../OrphanPage/OwnDay';
import HIBasicBanner from '../HIBasicBanner';
import Header from '../Header';
import MobileFixedNavbar from '../MobileFixedNavbar';

function RecentWorks(props) {

  const [
    glimpseIntoSection,
    setGlimpseIntoSection,
  ] = useState({});


  useEffect(() => {
    getEspotData();
    props.doNotScroll();
  },[])

  const getEspotData = () => {
    apiManager
      .get(`${espotAPI  }GI_HomeInteriorsRecentWork`)
      .then(response => {
        const { data } = response || {};
        setGlimpseIntoSection(data.data[2]);
      })
      .catch(error => {
        console.log(error);
      })
  }



  return (
    <div>
      <Header 
        pageSource = 'HI_RecentWorks'
        source=''
        showModal
      />
      {isMobile() ? (
        <>
          <MobileFixedNavbar
            source=''
            showModal
            pageSource="HI_RecentWorks" />
        </>
      ) : (
        <></>
      )}
      <HIBasicBanner espotName= "GI_HomeInteriorsRecentWork_Banner" pageSource = 'HI_RecentWorks' />
      <ImagesContainer />
      <PartnersPanel />
      {glimpseIntoSection.title == "" ? <></> :  <GlimpseInto title={glimpseIntoSection.title} videoLinks={glimpseIntoSection.video_links} />  }

      {/* <GlimpseInto title={glimpseIntoSection.title} videoLinks={glimpseIntoSection.video_links} /> */}
      <OwnDay
        source=''
        showModal pageSource = 'HI_RecentWorks'/>
      {isMobile() ? <Form /> : null}
    </div>
  )
}

export default RecentWorks
